import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Icon, Form, Divider, List, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";
import GenericRateCell from "../../../components/rates/genericRateCell"
import StateRateCell from "../../../components/rates/stateRateCell"
import ChangeStateRateModal from "../../../components/rates/changeStateRateModal"

//Actions
import { initialStateFamilyRoom } from "../../../redux/actions/rates/familyRoom/fetchFamilyRoom";
import { deleteFamilyRoom } from "../../../redux/actions/rates/familyRoom/deleteFamilyRoom";
import { fetchFamilyRoomListCustom, initialStateFamilyRoomListCustom } from "../../../redux/slices/custom/rates/familyRoom/customFamilyRoomList.slice";
// Resources
import { scrollToTop } from "../../resources/utils";

export default function FamilyRoomList() {
  const { t } = useTranslation();
  let actualDate = new Date();
  let currentYear = actualDate.getFullYear();
  let rateType = "";
  let yacht = "";
  let days = "all";
  let state = 1;

  const familyRoomRateFilters = JSON.parse(localStorage.getItem("familyRoomRateFilters"));
  if (familyRoomRateFilters) {
    currentYear = familyRoomRateFilters.year;
    rateType = familyRoomRateFilters.rate;
    yacht = familyRoomRateFilters.yacht;
    days = familyRoomRateFilters.days;
    state = familyRoomRateFilters.state;
  }

  const { register, handleSubmit, errors, getValues } = useForm();
  const familyRoomRateStateCustom = useSelector((state) => state.customFamilyRoomList);
  const familyRoomRateState = useSelector((state) => state.familyRoomRateReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFamilyRoomListCustom({ year: currentYear, rate_id: rateType, yacht_id: yacht, days: days, state: state }));
    scrollToTop();
    return () => {
      dispatch(initialStateFamilyRoomListCustom());
    };
  }, []);

  if (familyRoomRateStateCustom.fetching || familyRoomRateState.fetching) {
    return <Loader active inline />;
  }

  if (familyRoomRateState.message === "resource deleted successfully") {
    dispatch(fetchFamilyRoomListCustom({ year: getValues("year"), rate_id: getValues("rate_id"), yacht_id: getValues("yacht_id"), days: getValues("days"), state: getValues("state") }));
    dispatch(initialStateFamilyRoom())
  }

  if (familyRoomRateState.message === "resource updated successfully") {
    dispatch(fetchFamilyRoomListCustom({ year: getValues("year"), rate_id: getValues("rate_id"), yacht_id: getValues("yacht_id"), days: getValues("days"), state: getValues("state") }));
    dispatch(initialStateFamilyRoom())
  }

  const onSubmit = (data) => {
    let familyRoomRateFilters = {
      year: getValues("year"),
      rate: getValues("rate_id"),
      yacht: getValues("yacht_id"),
      days: getValues("days"),
      state: getValues("state")
    };
    localStorage.setItem("familyRoomRateFilters", JSON.stringify(familyRoomRateFilters));
    dispatch(fetchFamilyRoomListCustom(data));
  };

  const handleDeleteFamilyRoom = (id) => {
    dispatch(deleteFamilyRoom(id));
  };

  return (
    <>
      {familyRoomRateState.error ? (
        <Message negative content={t(familyRoomRateState.error)} />
      ) : (
        ""
      )}
      <HeaderCatalog title={t("family_title")} message={familyRoomRateStateCustom.message} to="/familyRooms_new" />
      <Divider />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("general_year")}</label>
            <select name="year" defaultValue={currentYear} aria-expanded="true" ref={register}>
              {familyRoomRateStateCustom.years.map((year, index) => (
                <option key={index} value={year.year}>{year.year}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field required>
            <label>{t("general_rateType")}</label>
            <select name="rate_id" defaultValue={rateType} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {familyRoomRateStateCustom.rates.map((rateType) => (
                <option key={rateType.id} value={rateType.id}>{t(rateType.name)}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("general_yacht")}</label>
            <select name="yacht_id" defaultValue={yacht} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {familyRoomRateStateCustom.yachts.map((yacht) => (
                <option key={yacht.id} value={yacht.id}>{yacht.name}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("general_days")}</label>
            <select name="days" defaultValue={days} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              {familyRoomRateStateCustom.days.map((day, index) => (
                <option key={index} value={day.number_days}>{t(day.number_days)}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field>
            <label>{t("charter_state")}</label>
            <select name="state" defaultValue={state} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              <option value={1}>{t("active_tag")}</option>
              <option value={0}>{t("inactive_tag")}</option>
            </select>
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <Button type="submit" loading={familyRoomRateStateCustom.fetching ? true : false} color="green"><Icon name='search' />{t("search_button")}</Button>
          </Form.Field>
        </Form.Group>
      </Form>

      {familyRoomRateStateCustom.familyRooms !== undefined ? (
        <Table color="blue">
          <Table.Body>
            {familyRoomRateStateCustom.familyRooms.map((familyRoom) => (
              <>
                <Table.Row>
                  <Table.Cell colSpan='8'>
                    <div className="flex justify-between">
                      <div className=" flex flex-col p-2 ">
                        <h1 className="text-[18px]">{familyRoom.yacht}</h1>
                        <p className="font-semibold text-[15px] mt-[-13px]">{t("general_days")}: {familyRoom.days}</p>
                        <StateRateCell activation_date={familyRoom.activation_date} inactivation_date={familyRoom.inactivation_date} reason_deactivation={familyRoom.reason_deactivation} />
                      </div>
                      <div className=" flex items-center pr-6">
                        <List size="large">
                          <List.Item>
                            <List.Icon color='red' name={familyRoom.airplane_ticket === 1 ? 'plane' : 'dont'} />
                            <List.Content>
                              <List.Description>{familyRoom.airplane_ticket === 1 ? t("general_priceInclude") : t("general_priceNotInclude")} </List.Description>
                            </List.Content>
                          </List.Item>
                        </List>
                      </div>
                    </div>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("family_year")} </Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("family_type")} </Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("family_cabins")} </Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("passengers")} </Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("family_clientRate")} </Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("family_operatorRate")} </Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
                <Table.Row key={familyRoom.id} className='no-row-borders'>
                  <Table.Cell collapsing><ActiveIcon active={familyRoom.active} /></Table.Cell>
                  <Table.Cell>{familyRoom.year}</Table.Cell>
                  <Table.Cell>{t(familyRoom.rate)}</Table.Cell>
                  <Table.Cell>{familyRoom.cabins}</Table.Cell>
                  <Table.Cell>{familyRoom.passengers}</Table.Cell>
                  <Table.Cell><GenericRateCell rate={familyRoom.customer_rate} ticket={familyRoom.airplane_ticket} /></Table.Cell>
                  <Table.Cell><GenericRateCell rate={familyRoom.operator_rate} ticket={familyRoom.airplane_ticket} /></Table.Cell>

                  <Table.Cell collapsing>
                    {familyRoom.active != false ? (
                      <ChangeStateRateModal stateRate={familyRoom} stateError={familyRoomRateState.error} typeRate="FamilyRoomRate" />
                    ) : (
                      null
                    )}
                    {(!familyRoom.active && !familyRoom.reason_deactivation) && (
                      <>
                        <Link to={`/familyRooms/${familyRoom.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                        <Modal
                          trigger={
                            <Button circular color='red' icon='trash alternate' />
                          }
                          content={t("family_delete")}
                          actions={[
                            t("canceled_button"),
                            {
                              key: "eliminar",
                              content: t("delete_button"),
                              className: "delete_button icon_color",
                              onClick: () => handleDeleteFamilyRoom(familyRoom.id),
                            },
                          ]}
                          size="tiny"
                        />
                      </>
                    )}
                  </Table.Cell>



                  {/* <Table.Cell textAlign="center">
                    {familyRoom.active != false ? (
                      <ChangeStateRateModal stateRate={familyRoom} stateError={familyRoomRateState.error} typeRate="FamilyRoomRate" />
                    ) : (
                      null
                    )}
                    <Link to={`/familyRooms/${familyRoom.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                    <Modal
                      trigger={
                        <Button circular color='red' icon='trash alternate' />
                      }
                      content={t("family_delete")}
                      actions={[
                        t("canceled_button"),
                        {
                          key: "eliminar",
                          content: t("delete_button"),
                          className: "delete_button icon_color",
                          onClick: () => handleDeleteFamilyRoom(familyRoom.id),
                        },
                      ]}
                      size="tiny"
                    />
                  </Table.Cell> */}
                </Table.Row>
              </>
            ))}
          </Table.Body>
        </Table>
      ) : (
        ""
      )}
    </>
  );
}
